{
  "add": "Agregar",
  "age": {
    "range": {
      "ADULT": "Adulto",
      "BABY": "Bebé",
      "CHILD": "Niño/a",
      "SENIOR": "Adulto mayor",
      "TURNING_SENIOR": "Próximo a adulto mayor",
      "YOUNG_ADULT": "Adulto joven",
      "YOUTH": "Joven"
    },
    "unknown": "No se sabe la edad",
    "years": "{{ years }} años"
  },
  "ages": {
    "ADULT": "(21-63) Adulto",
    "BABY": "(0-1) Bebé",
    "CHILD": "(1-5) Niño/a",
    "SENIOR": "(65+) Adulto mayor",
    "TURNING_SENIOR": "(64) Próximo a adulto mayor",
    "YOUNG_ADULT": "(19-20) Adulto joven",
    "YOUTH": "(6-18) Joven"
  },
  "back": "Atrás",
  "cancel": "Cancelar",
  "childCaregiverStatus": {
    "CAREGIVER": "Sí",
    "NOT_CAREGIVER": "No"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Estado migratorio válido (tarjeta verde, etc.)",
    "NOT_ANSWERED": "Prefiero no decir",
    "US_CITIZEN": "Ciudadano de EE. UU.",
    "US_NATIONAL": "Nacional de EE. UU."
  },
  "clear": "Borrar",
  "clearAddress": "Borrar dirección",
  "clearFilters": "Quitar filtros",
  "clinic": "Clínica",
  "close": "Cerrar",
  "continue": "Continuar",
  "dateOfBirth": "Fecha de nacimiento",
  "datePicker": {
    "placeholder": "Elija una fecha",
    "required": "Por favor, elige una fecha."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} día",
    "daysWithCount_other": "{{count}} días",
    "monthsWithCount_one": "{{count}} mes",
    "monthsWithCount_other": "{{count}} meses",
    "yearsWithCount_one": "{{count}} año",
    "yearsWithCount_other": "{{count}} años"
  },
  "day": "Día",
  "delete": "Borrar",
  "discardFormChangesDialog": {
    "cancelButton": "Volver a editar",
    "confirmButton": "Salir de todos modos",
    "creating": "creando",
    "description": "Tiene cambios sin guardar en lo que está {{action}}. Si sale de esta página, perderá su progreso.",
    "entity": "dato",
    "title": "¿Seguro que quiere salir?",
    "updating": "editando"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Prueba de inmigración",
    "PROOF_OF_EXEMPTION": "Prueba de exención",
    "PROOF_OF_EXPENSE": "Prueba de gastos",
    "PROOF_OF_IDENTITY": "Prueba de identidad",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Prueba de ingresos y trabajo",
    "PROOF_OF_INSURANCE": "Prueba de seguro del trabajo u otro seguro",
    "PROOF_OF_RESIDENCE": "Prueba de domicilio",
    "PROOF_OF_WORK": "Prueba de trabajo",
    "SOCIAL_SECURITY_NUMBER": "Número de Seguro Social"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Pensión pagada a ex-pareja",
    "AUTHORIZED_EMPLOYMENT_ID": "Identificación de trabajo autorizada",
    "BANK_STATEMENTS": "Estados de cuenta bancarios",
    "BIRTH_CERTIFICATE": "Acta de nacimiento",
    "CHILDCARE": "Cuidado de niños",
    "CHILDS_BIRTH_CERTIFICATE": "Acta de nacimiento del niño",
    "CHILDS_PASSPORT": "Pasaporte del niño",
    "COURT_ORDERED_STATEMENTS": "Papeles de la corte",
    "DOCTORS_NOTE": "Nota del médico",
    "DRIVERS_LICENSE": "Licencia de conducir",
    "EXPENSE_OTHER": "Otro",
    "FOSTER_CARE_VERIFICATION_LETTER": "Carta de verificación de cuidado de crianza",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Papeles de tutela o custodia",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Papeles de inmigración",
    "INSURANCE_CARD": "Tarjeta de seguro",
    "INSURANCE_CARRIER_INFO": "Datos de la aseguradora (nombre y dirección)",
    "INSURANCE_POLICY_NUMBER": "Número de póliza",
    "IRA_CONTRIBUTIONS": "Aportes a cuenta IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Carta de su empleador",
    "MEDICAL_EXPENSE": "Gasto médico",
    "MEDICARE_CARD": "Tarjeta de Medicare",
    "MORTGAGE_STATEMENT": "Estado de cuenta de la hipoteca",
    "MOVING_EXPENSES": "Gastos de mudanza",
    "PASSPORT": "Pasaporte",
    "PAY_STUBS": "Talones de pago (últimos 30 días)",
    "PENSION_STATEMENTS": "Comprobantes de pensión",
    "PROPERTY_TAX_BILL": "Recibo de impuestos a la propiedad",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Papeles de liberación o salida",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Recibo de renta o contrato de alquiler",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Constancia de inscripción escolar o certificado de notas",
    "SIGNED_LETTER": "Carta firmada",
    "SIGNED_TIMESHEETS": "Hojas de horas firmadas",
    "SNAP_TANF_VERIFICATION_LETTER": "Carta de verificación de SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "Tarjeta de Seguro Social",
    "SSA_STATEMENTS": "Cartas del Seguro Social (SSA)",
    "SSDI_STATEMENTS": "Cartas de discapacidad (SSDI)",
    "STATE_ID": "Identificación del estado",
    "STUDENT_LOANS": "Préstamos estudiantiles",
    "TAX_RETURN": "Declaración de impuestos (más reciente)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Certificado de inscripción en capacitación o programa de aprendiz",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Carta de inscripción en programa de tratamiento",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tarjeta o carta de inscripción tribal",
    "TUITION_FEES": "Matrícula y cuotas",
    "UNEMPLOYMENT_STATEMENTS": "Comprobantes de desempleo",
    "USCIS_ID": "ID de USCIS (no ciudadanos)",
    "UTILITY_BILL": "Recibo de servicios (luz, agua, gas)",
    "VA_DISABILITY_RATING_LETTER": "Carta de calificación de discapacidad del VA",
    "W2_FORMS": "Formularios W-2",
    "descriptions": {
      "ALIMONY_PAID": "Convenio de divorcio o separación",
      "AUTHORIZED_EMPLOYMENT_ID": "Documento de permiso de trabajo de USCIS",
      "BANK_STATEMENTS": "Estados de cuenta de los últimos 30 días",
      "BIRTH_CERTIFICATE": "Acta de nacimiento de EE. UU. con su nombre y fecha de nacimiento",
      "CHILDCARE": "Estado de cuenta, recibo o carta de su proveedor de cuidado de niños",
      "CHILDS_BIRTH_CERTIFICATE": "Acta de nacimiento con el nombre y la fecha de nacimiento de su hijo",
      "CHILDS_PASSPORT": "Pasaporte de EE. UU. con el nombre y la fecha de nacimiento de su hijo",
      "COURT_ORDERED_STATEMENTS": "Orden de la corte por manutención, pensión o compensación laboral",
      "DOCTORS_NOTE": "Carta de un médico que describa la condición médica, discapacidad o embarazo en que se basa esta exención",
      "DRIVERS_LICENSE": "Licencia vigente con su nombre, fecha de nacimiento y dirección",
      "EXEMPTION_SSA_STATEMENTS": "Carta que muestre el beneficio del Seguro Social de la persona que usted cuida",
      "EXEMPTION_SSDI_STATEMENTS": "Carta que muestre el beneficio por discapacidad de la persona que usted cuida",
      "EXPENSE_OTHER": "Orden de la corte o acuerdo escrito que muestre el monto del pago",
      "FOSTER_CARE_VERIFICATION_LETTER": "Carta de la agencia de cuidado de crianza de su estado que confirme su situación y su edad",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Orden judicial o papeles de custodia que muestren que usted es el cuidador legal del niño",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Permiso de trabajo, visa u otro papel de USCIS que muestre su estado",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Acta de nacimiento con su nombre y fecha de nacimiento",
      "IMMIGRATION_PASSPORT": "Pasaporte con su nombre y fecha de nacimiento",
      "INSURANCE_CARD": "Frente y vuelta de la tarjeta con nombre y número de póliza",
      "INSURANCE_CARRIER_INFO": "Papel con el nombre y dirección de la compañía de seguros",
      "INSURANCE_POLICY_NUMBER": "Papel que muestre su póliza o número de miembro",
      "IRA_CONTRIBUTIONS": "Estado de cuenta de su banco o proveedor de IRA",
      "I_20": "Formulario en papel de su escuela que muestra que puede estudiar en EE. UU.",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Carta que confirme su trabajo y lo que gana",
      "MEDICAL_EXPENSE": "Estado de cuenta, factura o recibo de su médico, hospital o farmacia",
      "MEDICARE_CARD": "Tarjeta de Medicare que muestre que está inscrito en Medicare Parte A y/o Parte B",
      "MORTGAGE_STATEMENT": "Estado de cuenta de los últimos 60 días con su dirección",
      "MOVING_EXPENSES": "Recibos de mudanza y una carta de su empleador",
      "PASSPORT": "Pasaporte de EE. UU. con su nombre y fecha de nacimiento",
      "PAY_STUBS": "Talones de los últimos 30 días que muestren su pago bruto y empleador",
      "PENSION_STATEMENTS": "Papel que muestre cuánto recibe de pensión al mes",
      "PROPERTY_TAX_BILL": "Recibo de impuestos con su dirección",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Papeles que muestren la fecha en que salió de la cárcel o prisión",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Recibo o contrato que muestre dónde vive ahora",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Carta o certificado de notas que muestre que está inscrito al menos medio tiempo",
      "SIGNED_LETTER": "Carta que confirme capacitación, escuela, programa de aprendiz o servicio comunitario",
      "SIGNED_TIMESHEETS": "Hojas de horas firmadas por su empleador o supervisor que muestren las horas trabajadas",
      "SNAP_TANF_VERIFICATION_LETTER": "Carta de su oficina de SNAP o TANF que confirme que cumple sus requisitos de trabajo",
      "SOCIAL_SECURITY_CARD": "Tarjeta con su nombre y los 9 números de Seguro Social",
      "SSA_STATEMENTS": "Carta que muestre su beneficio mensual del Seguro Social",
      "SSDI_STATEMENTS": "Carta que muestre su pago mensual por discapacidad",
      "STATE_ID": "Tarjeta de ID vigente con su nombre, fecha de nacimiento y dirección",
      "STUDENT_LOANS": "Estado de cuenta de su banco o administrador de su préstamo",
      "TAX_RETURN": "Declaración de impuestos completa del año pasado",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Certificado o carta que muestre que está inscrito en un programa de capacitación o de aprendiz",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Carta que confirme que está inscrito en un programa de tratamiento para drogas o alcohol",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Tarjeta de identificación tribal o carta que confirme que es miembro",
      "TUITION_FEES": "Recibo o factura de su escuela",
      "UNEMPLOYMENT_STATEMENTS": "Carta que muestre sus pagos por desempleo",
      "USCIS_ID": "Tarjeta verde, permiso de trabajo o certificado de ciudadanía",
      "UTILITY_BILL": "Recibo de los últimos 60 días (luz, agua, gas o teléfono) con su dirección",
      "VA_DISABILITY_RATING_LETTER": "Carta del VA que muestre su calificación de discapacidad del 100%",
      "W2_FORMS": "W-2 más reciente que muestre su empleador y su salario"
    }
  },
  "documents": {
    "choosePhoto": "Elegir foto",
    "takePhoto": "Tomar foto"
  },
  "done": "Listo",
  "edit": "Editar",
  "email": "Correo electrónico",
  "error": "Error",
  "errorFallback": {
    "description": "Tuvimos un problema al cargar esta página.",
    "resetCta": "Intentar de nuevo",
    "title": "Algo salió mal."
  },
  "errors": {
    "appleSsoNotSupported": "No puedes usar Apple para entrar. Por favor, elige otra opción.",
    "emptyHomeAddress": "Por favor, escribe y selecciona tu dirección, o marca \"Sin dirección fija\".",
    "emptyMailingAddress": "Por favor, escribe y selecciona una dirección de correo, o marca \"Sin dirección de correo\".",
    "googleSsoNotSupported": "No puedes usar Google para entrar. Por favor, elige otra opción.",
    "invalidEmail": "Por favor, escribe un correo electrónico válido (ejemplo: nombre@correo.com).",
    "selectValidOption": "Por favor, elige una opción válida.",
    "unableToCreateApplications": "No pudimos enviar tus solicitudes. Revisa tu internet e intenta de nuevo.",
    "unauthenticated": "Por favor, inicia sesión para continuar.",
    "unauthorized": "No tienes permiso para entrar. Si crees que es un error, escríbenos a support@pointcare.com.",
    "unknown": "Algo salió mal. Por favor, intenta de nuevo."
  },
  "exit": "Salir",
  "female": "Mujer",
  "filesWithCount_one": "{{count}} archivo",
  "filesWithCount_other": "{{count}} archivos",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Seguro por medio del trabajo",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Otro",
    "PRIVATE": "Seguro privado o del Mercado de la ACA",
    "TRICARE": "TRICARE (seguro militar)",
    "VA": "Programa de salud de Veteranos (VA)"
  },
  "home": "Inicio",
  "householdMember": "Miembro del hogar",
  "listConnector": " y ",
  "listSeparator": ", ",
  "loading": "Cargando...",
  "login": {
    "checkYourEmail": "Revise su correo {{email}} para ver el enlace de entrada.",
    "placeholder": "nombre@ejemplo.com",
    "sendEmail": "Enviar correo"
  },
  "longDateFormat": "D [de] MMMM [de] YYYY",
  "male": "Hombre",
  "maritalStatus": {
    "COMMON_LAW": "Matrimonio de hecho",
    "DIVORCED": "Divorciado/a",
    "MARRIED": "Casado/a",
    "NEVER_MARRIED": "Nunca se ha casado",
    "REGISTERED_DOMESTIC_PARTNER": "Pareja de hecho registrada",
    "SEPARATED": "Separado/a",
    "WIDOWED": "Viudo/a"
  },
  "marketplace": "Mercado de la ACA",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Parte C)",
    "NOT_SURE": "No estoy seguro",
    "ORIGINAL": "Partes A y B (Original)"
  },
  "member_one": "{{count}} miembro",
  "member_other": "{{count}} miembros",
  "month": "Mes",
  "next": "Siguiente",
  "no": "No",
  "noResults": "No se encontraron resultados",
  "noneOfTheAbove": "Ninguno de los anteriores",
  "ok": "Aceptar",
  "open": "Abrir",
  "or": "o",
  "pagination": {
    "goToFirstPage": "Ir a la primera página",
    "goToLastPage": "Ir a la última página",
    "goToNextPage": "Ir a la siguiente página",
    "goToPreviousPage": "Ir a la página anterior",
    "morePages": "Más páginas",
    "pagination": "Páginas",
    "rowsPerPage": "Filas por página",
    "rowsResults": "{{from}} a {{to}} de {{total}} resultados",
    "showingPrefix": "Mostrando "
  },
  "payFrequency": {
    "ANNUALLY": "Al año",
    "BI_WEEKLY": "Cada 2 semanas",
    "MONTHLY": "Al mes",
    "WEEKLY": "Por semana"
  },
  "pdfViewer": {
    "loading": "Cargando documento..."
  },
  "program_one": "{{count}} programa",
  "program_other": "{{count}} programas",
  "progressIndicator": "Progreso: {{progress}} de {{total}} listo",
  "relationships": {
    "CHILD": "Hijo/a",
    "FOSTER_CHILD": "Hijo/a de crianza",
    "GRANDCHILD": "Nieto/a",
    "GRANDPARENT": "Abuelo/a",
    "OTHER": "Otro",
    "PARENT": "Padre/Madre",
    "PARTNER": "Pareja",
    "SIBLING": "Hermano/a",
    "SPOUSE": "Esposo/a",
    "STEPCHILD": "Hijastro/a"
  },
  "required": "Este campo es obligatorio.",
  "returnToDashboard": "Volver al inicio",
  "save": "Guardar",
  "saveChanges": "Guardar cambios",
  "share": "Compartir",
  "sidebar": {
    "title": "Menú lateral",
    "toggle": "Cambiar menú"
  },
  "signOut": "Salir",
  "skip": "Saltar",
  "stepIndicator": "Paso {{currentStep}} de {{totalSteps}}",
  "submit": "Enviar",
  "tabs": {
    "home": "Inicio"
  },
  "taxFilingStatus": {
    "HEAD": "Cabeza de familia",
    "JOINTLY": "Casados declarando juntos",
    "NON_FILER": "No declara impuestos",
    "SEPARATELY": "Casados declarando por separado",
    "SINGLE": "Soltero/a",
    "WIDOWER": "Viudo/a con hijo dependiente"
  },
  "theme": "Tema",
  "time": {
    "am": "AM",
    "pm": "PM"
  },
  "undo": "Deshacer",
  "unknown": "No se sabe",
  "uploadButton": {
    "title": "Subir un archivo o tomar foto"
  },
  "validation": {
    "atLeastOneOption": "Por favor, elige al menos una opción.",
    "genericError": "Eso no funcionó. Por favor, intenta de nuevo.",
    "invalidCode": "Ese código no coincide. Revísalo e intenta de nuevo, o pide uno nuevo.",
    "invalidEmail": "Por favor, escribe un correo electrónico válido (ejemplo: nombre@correo.com).",
    "invalidNumber": "Por favor, escribe un número válido.",
    "invalidPassword": "Esa contraseña no es correcta. Por favor, intenta de nuevo.",
    "invalidPhone": "Por favor, escribe un número de teléfono de 10 dígitos.",
    "invalidSsn": "Tu número de Seguro Social solo debe tener números (sin guiones ni espacios).",
    "invalidSsnFormat": "Ese número de Seguro Social no parece válido. Por favor, revísalo e intenta de nuevo.",
    "invalidSsnLength": "Por favor, escribe tu número de Seguro Social de 9 dígitos.",
    "numberMustBeNonNegative": "Por favor, escribe un número que sea cero o más alto.",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "requiredField": "Por favor, completa este espacio.",
    "requiredFields": "Por favor, completa todos los campos obligatorios.",
    "requiredNonNegative": "Por favor, escribe un número que sea cero o más alto.",
    "requiredPassword": "Por favor, escribe tu contraseña.",
    "unknown": "Algo salió mal. Por favor, intenta de nuevo."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Ingresa tu correo electrónico para completar el inicio de sesión",
    "verify": "Comprobar",
    "verifyError": "No pudimos verificar tu enlace para entrar. Es posible que haya vencido. Por favor, pide uno nuevo."
  },
  "whoApplies": "¿A quién le aplica esto?",
  "whoIsApplying": "¿Quién está aplicando?",
  "year": "Año",
  "yes": "Sí",
  "zoom": "Tamaño",
  "zoomIn": "Aumentar",
  "zoomOut": "Alejar",
  "zoomReset": "Reiniciar tamaño"
}
